import React, { useState, useEffect } from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import CipHeader from "../Components/CipHeader";
import cogoToast from "cogo-toast";
import AddRefillTimeEntry from "../Components/AddRefillTimeEntry";
import { Modal } from "react-responsive-modal";

import { kaReducer, Table } from "ka-table";
import { search, loadData, updateData } from "ka-table/actionCreators";
import { ActionType, SortingMode, PagingPosition } from "ka-table/enums";
import "react-loader-spinner/dist/loader/css/react-spinner-loader.css";
import Loader from "react-loader-spinner";
import refillService from "../services/refill-service";
import facilityService from "../services/facility-service";

const dayOptions = [
  { key: "SUN", value: "Sunday" },
  { key: "MON", value: "Monday" },
  { key: "TUE", value: "Tuesday" },
  { key: "WED", value: "Wednesday" },
  { key: "THU", value: "Thursday" },
  { key: "FRI", value: "Friday" },
  { key: "SAT", value: "Saturday" },
];
const tablePropsInit = {
  columns: [
    { key: "fac_id", title: "Facility ID" },
    { key: "fac_name", title: "Facility Name" },
    { key: "day_name", title: "Day" },
    { key: "day", style: { display: "none" } },
    { key: "time_stamp", title: "Time" },
    { key: "Actions", title: "Actions" },
  ],
  singleAction: loadData(),
  sortingMode: SortingMode.Single,
  rowKeyField: "id",
  search: ({ searchText, rowData, column }) => {
    if (column.key === "passed") {
      return (
        (searchText === "false" && !rowData.passed) ||
        (searchText === "true" && rowData.passed)
      );
    }
  },
  paging: {
    enabled: true,
    pageIndex: 0,
    pageSize: 50,
    position: PagingPosition.Bottom,
  },
};

const RefillTime = ({ history }) => {
  const [loading, setLoading] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);
  const [editData, setEditData] = useState({});
  const [facList, setFacList] = useState([]);

  const onCloseRepModal = () => {
    setModalOpen(false);
    setEditData({});
    getEntries();
  };

  useEffect(() => {
    getFacilities();
  }, []);
  async function getFacilities(parentId) {
    try {
      setLoading(true);
      let totalFacList = await facilityService.getFacilities();
      if (totalFacList) {
        setFacList(totalFacList);
      }
      setLoading(false);
    } catch (e) {
      const { hide } = cogoToast.error(
        "Error while getting facilities details. Please try after sometime.",
        {
          hideAfter: 15,
          onClick: () => {
            hide();
          },
        }
      );
      setLoading(false);
    }
  }
  const getEntries = async () => {
    try {
      const resp = await refillService.getEntries();
      dispatch(updateData(resp));
    } catch (e) {
      const { hide } = cogoToast.error(
        "Error getting entries. Please try after sometime.",
        {
          hideAfter: 15,
          onClick: () => {
            hide();
          },
        }
      );
    }
  };

  const handleDelete = async (id) => {
    try {
      await refillService.deleteEntry(id);
      getEntries();
    } catch (e) {
      const { hide } = cogoToast.error(
        "Error deleting entry. Please try after sometime.",
        {
          hideAfter: 15,
          onClick: () => {
            hide();
          },
        }
      );
    }
  };
  const CustomCell = ({ rowData }) => {
    return (
      <div className="action_btns">
        <span className="inline-block mr-3">
          <img
            src="/img/edit_icon.svg"
            className="mt-1 w-4 h-4 cursor-pointer"
            alt="logo"
            onClick={() => {
              setModalOpen(true);
              setEditData(rowData);
            }}
          />
        </span>
        {rowData.fac_id !== 0 && (
          <span className="inline-block">
            <img
              src="./img/delete.svg"
              className="w-4 h-4 cursor-pointer"
              alt="delete"
              title="Delete"
              onClick={(e) => {
                handleDelete(rowData.id);
              }}
            />
          </span>
        )}
      </div>
    );
  };
  const CustomCell1 = ({ rowData }) => {
    return (
      <div>
        {rowData?.day_name !== "-"
          ? dayOptions.find((item) => item.key === rowData.day_name).value
          : "-"}
      </div>
    );
  };
  const CustomCell2 = ({ rowData }) => {
    return (
      <div>
        {facList.length && rowData?.fac_id !== 0
          ? facList.find((item) => item.id === rowData.fac_id).name
          : "DEFAULT"}
      </div>
    );
  };
  const [tableProps, changeTableProps] = useState(tablePropsInit);
  const dispatch = async (action) => {
    changeTableProps((prevState) => kaReducer(prevState, action));
    if (action.type === ActionType.LoadData) {
      setLoading(true);
      let resp = await refillService.getEntries();
      resp.sort(
        (d1, d2) =>
          new Date(d2.updatedAt).getTime() - new Date(d1.updatedAt).getTime()
      );
      setLoading(false);
      dispatch(updateData(resp));
    }
  };

  return (
    <>
      <CipHeader />
      <div
        className={`inline-block customtop absolute z-50 ${
          loading ? "show" : "hidden"
        }`}
      >
        <Loader
          type="Oval"
          color="#00BFFF"
          height={50}
          width={50}
          timeout={300000} //3 secs
        />
      </div>
      <div className="bg-white w-5/6 mx-auto mt-6 mb-4 rounded shadow-md">
        <div className="tableHeader flex clearboth shadow-md py-8 pl-3">
          <div className="w-1/2 text-darkclr font-semibold leading-10 ">
            <span className="text-xl">REFILL TIME</span>
          </div>
          <div className="w-full sm:w-1/2 text-right">
            <span className="relative">
              <input
                type="search"
                defaultValue={tableProps.searchText}
                onChange={(event) => {
                  dispatch(search(event.currentTarget.value));
                }}
                placeholder=" Search"
                className="border rounded w-5/12 mb-3 h-10 mr-3 focus:outline-none focus:none pl-1 font-light align-bottom"
              />
              <img
                src="/img/search-2.svg"
                alt=""
                className="absolute w-4 h-4 mb-2 right-5 top-1 bottom-3"
              ></img>
            </span>
            <span className="mr-3">
              <button
                onClick={() => setModalOpen(true)}
                className={
                  loading
                    ? "opacity-50 cursor-not-allowed text-white w-full sm:w-auto h-8 px-6 bg-header_bg rounded text-xs font-medium capitalize focus:outline-none"
                    : "text-white w-full sm:w-auto mb-4 h-8 px-6  bg-header_bg rounded text-xs font-medium capitalize focus:outline-none"
                }
              >
                ADD ENTRY
              </button>
            </span>
          </div>
        </div>
        <div className="p-2 text-xs usersList gridList overflow-x-auto">
          <Table
            {...tableProps}
            childComponents={{
              cellText: {
                content: (props) => {
                  // eslint-disable-next-line default-case
                  switch (props.column.key) {
                    case "Actions":
                      return <CustomCell {...props} />;
                    case "day_name":
                      return <CustomCell1 {...props} />;
                    case "fac_name":
                      return <CustomCell2 {...props} />;
                  }
                },
              },
            }}
            dispatch={dispatch}
          />
        </div>
        <div>
          <Modal open={modalOpen} onClose={onCloseRepModal}>
            <AddRefillTimeEntry
              name={editData?.id ? "Edit Refill Time" : "Create Refill Time"}
              editData={editData}
              dayOptions={dayOptions}
              onCloseRepModal={onCloseRepModal}
            ></AddRefillTimeEntry>
          </Modal>
        </div>
      </div>
    </>
  );
};

export default withRouter(
  connect(
    () => ({}),
    (dispatch) => {
      return bindActionCreators({}, dispatch);
    }
  )(RefillTime)
);
